import Box from '@/Atoms/Box';
import * as React from 'react';
import {
  Text,
  View,
  StyleSheet,
  ImageBackground,
  Image,
  Pressable,
} from 'react-native';
import chessFooterBackground from '@/Assets/Images/png/chess_footer_background.png';
import logo from '@/Assets/Images/png/circle_chess_logo.png';
import whatsapp from '@/Assets/Images/png/whatsapp_say_hi.png';
import Entypo from 'react-native-vector-icons/Entypo';
import AntDesign from 'react-native-vector-icons/AntDesign';
import CCColors from '@/Utils/CCColors';
import CCText from '@/Atoms/CCText';
import {useNavigation} from '@react-navigation/native';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import ConditionalRender from '@/Atoms/ConditionalRender';
import Spacer from '@/Atoms/Spacer';

interface FooteProps {}

const Footer = () => {
  const navigation = useNavigation();
  const {isMobileOrTab} = useMediaQuery();

  return (
    <ImageBackground
      source={chessFooterBackground}
      style={{flex: 1, backgroundColor: `${CCColors.Black}`}}>
      <Box marginLeft="5%" marginRight="5%">
        <Box
          flexDirection={!isMobileOrTab ? 'row' : 'column'}
          marginTop={100}
          marginBottom={60}
          alignItems={!isMobileOrTab ? 'center' : 'flex-start'}
          justifyContent="space-between">
          <Image
            resizeMethod="resize"
            source={logo}
            alt="logo"
            style={{width: 162, height: 32}}
          />
          <ConditionalRender
            condition={isMobileOrTab}
            childrenA={<Spacer spacing={40} />}
          />
          <Box flexDirection="row" gap={10}>
            <Box
              onPress={() =>
                window.open(
                  'https://www.facebook.com/CircleChess?mibextid=ZbWKwL',
                  '_blank',
                )
              }
              style={{
                padding: 10,
                borderRadius: 12,
                backgroundColor: CCColors.Primary.Brown,
              }}>
              <Entypo name="facebook" size={24} color={CCColors.White} />
            </Box>
            <Box
              onPress={() =>
                window.open(
                  'https://www.instagram.com/circlechess?igsh=MW5pZ2J3cDR6eGgyaw==',
                  '_blank',
                )
              }
              style={{
                padding: 10,
                borderRadius: 12,
                backgroundColor: CCColors.Primary.Brown,
              }}>
              <Entypo name="instagram" size={24} color={CCColors.White} />
            </Box>
            <Box
              onPress={() =>
                window.open('https://x.com/CircleChesscom', '_blank')
              }
              style={{
                padding: 10,
                borderRadius: 12,
                backgroundColor: CCColors.Primary.Brown,
              }}>
              <AntDesign name="twitter" size={24} color={CCColors.White} />
            </Box>
            <Box
              onPress={() =>
                window.open(
                  'https://www.youtube.com/@CircleChessTeam',
                  '_blank',
                )
              }
              style={{
                padding: 10,
                borderRadius: 12,
                backgroundColor: CCColors.Primary.Brown,
              }}>
              <AntDesign name="youtube" size={24} color={CCColors.White} />
            </Box>
            <Pressable
              onPress={() =>
                window.open(
                  'https://api.whatsapp.com/send/?phone=%2B919620006600&text=Hi&type=phone_number&app_absent=0',
                  '_blank',
                )
              }>
              <Image
                resizeMethod="resize"
                source={whatsapp}
                style={{width: 130, height: 50, borderRadius: 12}}
              />
            </Pressable>
          </Box>
        </Box>
        <Box flexDirection="row" gap={20}>
          <Pressable
            onPress={() => {
              window.open('https://circlechess.com/about', '_blank');
            }}>
            <CCText fontSize={16} fontWeight="regular" color={CCColors.White}>
              About
            </CCText>
          </Pressable>
          <Pressable
            onPress={() => {
              window.open(
                'https://circlechess.com/TnC/TermsAndConditions.pdf',
                '_blank',
              );
            }}>
            <CCText fontSize={16} fontWeight="regular" color={CCColors.White}>
              Terms of Use
            </CCText>
          </Pressable>
          <Pressable>
            <Pressable
              onPress={() => {
                window.open(
                  'https://circlechess.com/TnC/PrivacyPolicy.pdf',
                  '_blank',
                );
              }}>
              <CCText fontSize={16} fontWeight="regular" color={CCColors.White}>
                Privacy Policy
              </CCText>
            </Pressable>
          </Pressable>
        </Box>
        <CCText fontSize={16} fontWeight="regular" style={{marginVertical: 20}}>
          Copyright (c) Circlechess Technologies Pvt Ltd, 2023. All rights
          reserved.
        </CCText>
      </Box>
    </ImageBackground>
  );
};

export default Footer;

const styles = StyleSheet.create({
  container: {},
});
